import { withInstall } from '@zoryn/utils'
import Link from './src/link.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZLink: SFCWithInstall<typeof Link> = withInstall(Link)
export default ZLink

export * from './src/link'
